//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../no/Builder.js";
let d=[[[0,"AnnotationScale",1,0],[0,"CreateEndAnnotation",1,0],[0,"CreateStartAnnotation",1,0],[0,"SymbolType",1,0]],[[["color","style","width"],"UpdateColorStyleWidth",{},3,0]],[]];
SPLM.Features.AECDesign.LevelLinePreferencesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.LevelLinePreferencesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;